var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemove = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 15 15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-691.000000, -458.000000)",
  fill: "#E76F67",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(282.937500, 184.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.062500, 233.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M415.5,41 C411.340909,41 408,44.3409091 408,48.5 C408,52.6590909 411.340909,56 415.5,56 C419.659091,56 423,52.6590909 423,48.5 C423,44.3409091 419.659091,41 415.5,41 Z M419.590909,48.8409091 C419.590909,49.0454545 419.454545,49.1818182 419.25,49.1818182 L416.352273,49.1818182 C416.25,49.1818182 414.75,49.1818182 414.647727,49.1818182 L411.75,49.1818182 C411.545455,49.1818182 411.409091,49.0454545 411.409091,48.8409091 L411.409091,48.1590909 C411.409091,47.9545455 411.545455,47.8181818 411.75,47.8181818 L414.647727,47.8181818 C414.75,47.8181818 416.25,47.8181818 416.352273,47.8181818 L419.25,47.8181818 C419.454545,47.8181818 419.590909,47.9545455 419.590909,48.1590909 L419.590909,48.8409091 Z"
}))))))));
export default SvgRemove;